import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetUrl } from "../config/GetUrl";

export const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: GetUrl.API_URL,
  }),
  endpoints: (builder) => ({
    CreateCategoryPost: builder.mutation({
      query: (data) => ({
        url: "/api/v1/Admin/createCategory",
        method: "POST",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    GetCategoryListByIds:builder.mutation({
      query: (categoryIds) => ({
        url: "/api/v1/Admin/getCategoryListByIds",
        method: "POST",
        body: categoryIds,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    GetCategory: builder.query({
  query: ({ search = "", page = 1, limit = 100 } = {}) => ({
    url: "/api/v1/User/get-categories",
    method: "GET",
    params: { search, page, limit }
  }),

  
transformResponse: (response) => {
    /* GALAXY_CATEGORY_LIST_FINAL_V1 */

    const payload =
      response?.data?.data ??
      response?.data ??
      response ??
      {};

    const rawCategories =
      Array.isArray(payload)
        ? payload
        : (
            payload?.categories ??
            response?.categories ??
            response?.data?.categories ??
            response?.data?.data?.categories ??
            []
          );

    const categories =
      Array.isArray(rawCategories)
        ? rawCategories
        : [];

    const pagination =
      payload?.pagination ??
      response?.pagination ??
      response?.data?.pagination ??
      response?.data?.data?.pagination ??
      {};

    /*
      Hybrid result supports all historical Admin usages:
      result.map(...)
      result.categories
      result.data.categories
    */
    return Object.assign(
      [...categories],
      {
        categories,
        pagination,

        data: {
          categories,
          pagination
        }
      }
    );
  }
}),
    GetSingleCategory: builder.query({
      query: (id) => ({
        url: `/api/v1/Admin/getCategoryDetail/${id}`,
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    EditCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api/v1/Admin/updateCategory/${id}`,
        method: "PUT",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    DeleteCategory: builder.mutation({
      query: (id) => ({
        url: `/api/v1/Admin/deleteCategory/${id}`,
        method: "DELETE",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateCategoryPostMutation,
  useGetCategoryListByIdsMutation,
  useGetCategoryQuery,
  useGetSingleCategoryQuery,
  useEditCategoryMutation,
  useDeleteCategoryMutation,
} = categoryApi;

categoryApi.enhanceEndpoints({
  addTagTypes: ["GalaxyCategoryOrder"],
  endpoints: {
    GetCategory: { providesTags: ["GalaxyCategoryOrder"] }
  }
});

const galaxyOrderApi = categoryApi.injectEndpoints({
  endpoints: builder => ({
    GalaxyCategoryOrder: builder.query({
      query: () => ({
        url: "/api/v1/Admin/category-order",
        method: "GET",
        headers: {
          authorization: "Bearer " + localStorage.getItem("tokenAdmin")
        }
      }),
      providesTags: ["GalaxyCategoryOrder"]
    }),
    SaveGalaxyCategoryOrder: builder.mutation({
      query: body => ({
        url: "/api/v1/Admin/category-order",
        method: "PUT",
        body,
        headers: {
          authorization: "Bearer " + localStorage.getItem("tokenAdmin")
        }
      }),
      invalidatesTags: (result, error) =>
        error ? [] : ["GalaxyCategoryOrder"]
    })
  }),
  overrideExisting: false
});

export const {
  useGalaxyCategoryOrderQuery,
  useSaveGalaxyCategoryOrderMutation
} = galaxyOrderApi;
